const AUTH_PATHS = new Set(["/login", "/signup", "/reset-password"]);

export const safeReturnPath = (search: string): string | null => {
  const value = new URLSearchParams(search).get("returnTo");
  if (!value?.startsWith("/") || value.startsWith("//") || value.includes("\\")) return null;
  const pathname = value.split(/[?#]/, 1)[0];
  return AUTH_PATHS.has(pathname) ? null : value;
};

export const loginUrl = (returnTo: string): string => `/login?${new URLSearchParams({ returnTo })}`;
